import { render, staticRenderFns } from "./Subvention.vue?vue&type=template&id=d38174d4"
import script from "./Subvention.vue?vue&type=script&lang=js"
export * from "./Subvention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports